import React from 'react';
import { Heading } from '@wix/design-system';

export const FaqHeading: React.FC = ({ children }) => {
  return <Heading appearance="H2">{children}</Heading>;
};

export const MobileFaqHeading: React.FC = ({ children }) => {
  return <Heading appearance="H3">{children}</Heading>;
};
